import "./payroll.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import API from "../../api/axiosConfig";
import HRreports from "../HRreports/HRreports";
import { Container, Button } from "react-bootstrap";
import Title from "../../components/title";
import MonthDate from "../../components/MonthDate/MonthDate";

function Payroll() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [payrolls, setPayrolls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const formatMonthName = (value) => {
    const date = new Date(value);
    const months = [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ];

    return `${months[date.getMonth()]} ${date.getFullYear()}`;
  };
  const calculatePayroll = async () => {
    setLoading(true);
    setMessage("");
    try {
      await API.post("/payroll/calculate", { month });
      const monthName = formatMonthName(month);

      setMessage(`مرتبات شهر ${monthName}`);
      fetchPayrolls();
    } catch (error) {
      setMessage("حصل خطأ أثناء الحساب");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!month) return;
    calculatePayroll();
  }, [month]);

  const fetchPayrolls = async () => {
    try {
      const response = await API.get(`/payroll`);
      setPayrolls(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPayrolls();
  }, [month]);

  return (
    <>
      <HRreports activeTab="salaryreport" />
      <Container className="pt-4">
        <Title
          title="مسيرات الرواتب"
          icon={<FontAwesomeIcon icon={faMoneyBill} />}
          style={{ width: "unset" }}
          classname="rmtit"
        />

        {/* التاريخ وزر الحساب على اليمين */}
        <div className="calc-actions d-flex gap-4 justify-content-end align-items-end" >
          {/* <div>
            <Button
              onClick={calculatePayroll}
              disabled={loading}
              className="styled-download-button p-2"
            >
              {loading ? "جاري الحساب..." : "احسب المرتبات"}
            </Button>
          </div> */}

          {/* <div>
            <Form.Control
              type="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="month-date"
            />
            <FontAwesomeIcon icon={faCalendar} className="calendar-icon" />
          </div> */}
          <MonthDate month={month} onChange={(e) => setMonth(e.target.value)}  />
        </div>

        {message && <h5 className="text-center">{message}</h5>}

        {/* جدول المرتبات */}
        {payrolls.length > 0 && (
          <div className="mt-4">
            <table className="printTabel">
              <thead className="printTabelHead">
                <tr></tr>
                <tr>
                  <th> م</th>
                  <th>إسـم الموظف</th>
                  <th>الأساسي</th>
                  <th>البدلات</th>
                  <th>مكافآت</th>
                  <th>خصومات</th>
                  <th>غياب</th>
                  <th>جزاءات</th>
                  <th>التأمين الاجتماعي</th>
                  <th>الصافي</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {payrolls.map((row, index) => (
                  <tr key={row.id}>
                    <td>{index + 1}</td>
                    <td>{row.employee.name}</td>
                    <td>{row.basic}</td>
                    <td>{row.allowance}</td>
                    <td>{row.additions}</td>
                    <td>{row.deductions}</td>
                    <td>{row.absence}</td>
                    <td>{row.investigations}</td>
                    <td>{row.socialinsurance}</td>

                    <td className="fw-bold">{row.net}</td>
                    <td>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                          window.open(`/payroll/${row.employee.id}`, "_blank");
                        }}
                      >
                        سند صرف
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Container>
    </>
  );
}

export default Payroll;
